<template>
  <span class="name">{{ item.name }}, <span class="country">{{ item.country }}</span></span>
</template>

<script>
export default {
  props: {
    item: {
      required: true,
    },
    searchText: {
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Autosuggest/ItemTemplate.vue